import React, {Component} from 'react';
import { Trans } from 'react-i18next';

import Dialog from '@material-ui/core/Dialog';
import DialogButton from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';

import Scale from './Scale.jsx';
import Orientation from './Orientation.jsx'
import Cartela from './Cartela.jsx'
import CellDensity from './CellDensity.jsx'
import Grid from './Grid.jsx';
import Service from './Service.jsx';

import i18n from '../resources/i18n';
import {properties} from '../resources/properties.js';

import IMG_PAISAJE_COLOR from '../img/paisaje-color.svg';
import IMG_PAISAJE_GRIS from '../img/paisaje-gris.svg';
import IMG_RETRATO_COLOR from '../img/retrato-color.svg';
import IMG_RETRATO_GRIS from '../img/retrato-gris.svg';

import IMG_CARTELA_V from '../img/Cartela_V.svg';
import IMG_CARTELA_V_GRIS from '../img/Cartela_V_gris.svg';
import IMG_CARTELA_H from '../img/Cartela_H.svg';
import IMG_CARTELA_H_GRIS from '../img/Cartela_H_gris.svg';

//POSTER
import POSTER_IMG_PAISAJE_COLOR from '../img/mapaPosterHorizontal.png';
import POSTER_IMG_PAISAJE_GRIS from '../img/mapaPosterHorizontalNoSeleccionado.png';
import POSTER_IMG_RETRATO_COLOR from '../img/mapaPosterVertical.png';
import POSTER_IMG_RETRATO_GRIS from '../img/mapaPosterVerticalNoSeleccionado.png';
import POSTER_IMG_PAISAJE_COLOR_LEYENDA from '../img/mapaPosterHorizontal_L.png';
import POSTER_IMG_PAISAJE_GRIS_LEYENDA from '../img/mapaPosterHorizontalNoSeleccionado_L.png';
import POSTER_IMG_RETRATO_COLOR_LEYENDA from '../img/mapaPosterVertical_L.png';
import POSTER_IMG_RETRATO_GRIS_LEYENDA from '../img/mapaPosterVerticalNoSeleccionado_L.png';

//Producto Options
import P_ELABORADO_COLOR from '../img/ELABORADO_COLOR.svg';
import P_ELABORADO_GRIS from '../img/ELABORADO_GRIS.svg';
import P_FOTO_COLOR from '../img/img-photo_activo.svg';
import P_FOTO_GRIS from '../img/img-photo.svg';
import P_POSTER_COLOR from '../img/img-poster_activo.svg';
import P_POSTER_GRIS from '../img/img-poster.svg';
/*import P_FOTO_COLOR from '../img/FOTO_COLOR.svg';import P_FOTO_GRIS from '../img/FOTO_GRIS.svg';
import P_POSTER_COLOR from '../img/POSTER_COLOR.svg';import P_POSTER_GRIS from '../img/POSTER_GRIS.svg';*/

import IMG_COORDENADAS_COLOR from '../img/coordenadas.svg';
import IMG_COORDENADAS_GRIS from '../img/coordenadas-gris.svg';
import IMG_CUADRICULA_COLOR from '../img/cuadricula.svg';
// import IMG_CUADRICULA_GRIS from '../img/cuadricula-gris.svg';
import IMG_CUADRICULA_GRIS from '../img/cuadricula-gris.png';
import IMG_1KM_COLOR from '../img/Cuadricula_1.svg';
import IMG_1KM_GRIS from '../img/Cuadricula_1-gris.svg';
import IMG_2KM_COLOR from '../img/Cuadricula_2.svg';
import IMG_2KM_GRIS from '../img/Cuadricula_2-gris.svg';
import IMG_5KM_COLOR from '../img/Cuadricula_5.svg';
import IMG_5KM_GRIS from '../img/Cuadricula_5-gris.svg';

import IMG_CARTOGRAFIA_1_MAPPED from '../img/Carousel/Cartografia/img91.jpg';
import portada_CYAN from '../img/Fondos/img53.png';

declare var M;

const theme = createTheme({
  palette: { primary: { 500: properties.BUTTON_THEME_COLOR } },
  overrides: { MuiButton: { containedPrimary: { color: 'white' } } }
});
const themeTitle = createTheme({
  palette: { primary: { 500: properties.TITLE_THEME_COLOR } },
  overrides: { MuiDialogTitle: { root: { backgroundColor: properties.TITLE_THEME_COLOR, color: 'white' } } }
});

class OptionMapSelectorSeries extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstRow: '25K',
      secondRow: '50K',
      activeRow: this.props.activeRow,
      orientation: this.props.orientation,

      orientationIMGPaisajeColor: IMG_PAISAJE_COLOR,
      orientationIMGPaisajeGris: IMG_PAISAJE_GRIS,
      orientationIMGRetratoColor: IMG_RETRATO_COLOR,
      orientationIMGRetratoGris: IMG_RETRATO_GRIS,
      cartelaVertical: IMG_CARTELA_V,
      cartelaVerticalGris: IMG_CARTELA_V_GRIS,
      cartelaHorizontal: IMG_CARTELA_H,
      cartelaHorizontalGris: IMG_CARTELA_H_GRIS,

      posterOrientationIMGPaisajeColor: POSTER_IMG_PAISAJE_COLOR,
      posterOrientationIMGPaisajeGris: POSTER_IMG_PAISAJE_GRIS,
      posterOrientationIMGRetratoColor: POSTER_IMG_RETRATO_COLOR,
      posterOrientationIMGRetratoGris: POSTER_IMG_RETRATO_GRIS,
      posterOrientationIMGPaisajeColor_L: POSTER_IMG_PAISAJE_COLOR_LEYENDA,
      posterOrientationIMGPaisajeGris_L: POSTER_IMG_PAISAJE_GRIS_LEYENDA,
      posterOrientationIMGRetratoColor_L: POSTER_IMG_RETRATO_COLOR_LEYENDA,
      posterOrientationIMGRetratoGris_L: POSTER_IMG_RETRATO_GRIS_LEYENDA,

      productoElaboradoColor: P_ELABORADO_COLOR,
      productoElaboradoGris: P_ELABORADO_GRIS,
      productoFotoColor: P_FOTO_COLOR,
      productoFotoGris: P_FOTO_GRIS,
      productoPosterColor: P_POSTER_COLOR,
      productoPosterGris: P_POSTER_GRIS,

      coordinatesIMGColor: IMG_COORDENADAS_COLOR,
      coordinatesIMGGris: IMG_COORDENADAS_GRIS,
      gridIMGColor: IMG_CUADRICULA_COLOR,
      gridIMGGris: IMG_CUADRICULA_GRIS,

      oneKMColor: IMG_1KM_COLOR,
      oneKMGris: IMG_1KM_GRIS,
      twoKMColor: IMG_2KM_COLOR,
      twoKMGris: IMG_2KM_GRIS,
      fiveKMColor: IMG_5KM_COLOR,
      fiveKMGris: IMG_5KM_GRIS,

      cellDensity: this.props.cellDensity,
      radioButtonOneChecked: 'checked',
      radioButtonTwoChecked: 'checked',
      parentState: this.props.parentState
    };
    this.showHelpGrid = false;
    this.enableVertical = this.props.parentState.verticalCartela || false;
    this.selectedProduct = this.props.parentState.seleccionadoProductoSeries || 'Elaborado';
    this.props.parentState.seleccionadoProductoSeries = this.props.parentState.seleccionadoProductoSeries || 'Elaborado';
    this.showSeries = true;
    this.currentHojaCount = 0;
    this.selectedHoja = 0;
    this.showSeralAlertWarning = false;
    this.enableLegend = this.props.parentState.posterLegend;
    this.allowClick = true;
  }

  setStateGlobal = (state, event, value) => {
    const {setParentState} = this.props;
    setParentState(state, event);
  }

  configAutoScale(scale) {
    if (this.props.pluginEdition.currentScale !== scale) {
      this.props.pluginEdition.currentScale = scale;
      window.mapJs.getLayers().filter(l=>(l.legend && l.legend.endsWith('(Líneas)')) || l.impl_.name === '__draw__' || l.from_parameters || l.layerAddedByEditionTools).forEach(l=>l.getFeatures().forEach(f=>{
        f.impl_.olFeature_.changed();
      }));
    }
  }

  setActiveRow = (event) => {
    let {parentState} = this.props;
    if (event.target.value === 'secondRow') {
      this.configAutoScale(50);
      this.props.actionScale('1:50.000');//, 'secondRow'
      parentState.cellDensity = "5";
      if (this.showHelpGrid) {
        window.grid25Layer.setVisible(false);
        window.grid50Layer.setVisible(true);
      }

      window.mapJs.setMaxZoom(15);
      window.mapJs.removeLayers(window.mapJs.getLayers().filter(l=>l.impl_.name === 'MTN' || l.impl_.name === 'Orto'));
      if (parentState.seleccionadoProductoSeries==='Foto') {
        window.mapJs.addLayers(['TMS*Orto*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*true*false', 'TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*false*false*14']);
      } else {
        window.mapJs.addLayers(['TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*true*false*14', 'TMS*Orto*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*false*false']);
      }
    } else {
      this.configAutoScale(25);
      this.props.actionScale('1:25.000');//, 'firstRow'
      parentState.cellDensity = "1";
      if (this.showHelpGrid) {
        window.grid50Layer.setVisible(false);
        window.grid25Layer.setVisible(true);
      }

      window.mapJs.setMaxZoom(18);
      window.mapJs.removeLayers(window.mapJs.getLayers().filter(l=>l.impl_.name === 'MTN' || l.impl_.name === 'Orto'));
      if (parentState.seleccionadoProductoSeries==='Foto') {
        window.mapJs.addLayers(['TMS*Orto*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*true*false', 'TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*false*false*16']);
      } else {
        window.mapJs.addLayers(['TMS*MTN*https://tms-mapa-raster.ign.es/1.0.0/mapa-raster/{z}/{x}/{-y}.jpeg*true*false*16', 'TMS*Orto*https://tms-pnoa-ma.idee.es/1.0.0/pnoa-ma/{z}/{x}/{-y}.jpeg*false*false']);
      }
    }
    this.setStateGlobal(parentState);
  }

  toggleHelpGrid = () => {
    if(this.showHelpGrid){
      window.grid50Layer.setVisible(false);
      window.grid25Layer.setVisible(false);
    }else{
      if(this.props.parentState.activeRow === 'secondRow'){
        window.grid50Layer.setVisible(true);
      }else{
        window.grid25Layer.setVisible(true);
      }
    }
    this.showHelpGrid = !this.showHelpGrid
    this.setStateGlobal(this.props.parentState);
  }

  toggleVertical = (respuesta) => {
    if(respuesta === 'medium Cartela'){
      if(this.enableVertical){
        this.enableVertical = false;
        this.props.parentState.verticalCartela = false;
        this.setStateGlobal(this.props.parentState);
        this.props.actionVertical(this.enableVertical);
      }
    }else{
      if (!this.enableVertical){
        this.enableVertical = true;
        this.props.parentState.verticalCartela = true;
        this.setStateGlobal(this.props.parentState);
        this.props.actionVertical(this.enableVertical);
      }
    }
  }

  toggleLegend = () => {
    this.enableLegend = !this.enableLegend;
    this.props.parentState.posterLegend = this.enableLegend;
    this.setStateGlobal(this.props.parentState);
    this.props.actionLegendPoster(this.props.parentState.posterLegend);
  }

  changeSelectedScale = (option) => {
    let {parentState} = this.props;
    switch (option) {
      case '40K':
        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:40.000';
          this.configAutoScale(40);
        }
        break;
      case '20K':
        if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:20.000';
          this.configAutoScale(20);
        }
        break;
      case '30K':
        if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:30.000';
          this.configAutoScale(30);
        }
        break;
      case '50K':
        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:50.000';
          this.configAutoScale(50);
        }
        break;
      case '60K':
        if (parentState.activeRow === 'secondRow') {
          parentState.scale = '1:60.000';
          this.configAutoScale(60);
        }
        break;
      case '2.5K':
        parentState.scale = '1:2.500';
        this.configAutoScale(2.5);
        break;
      case '5K':
        parentState.scale = '1:5.000';
        this.configAutoScale(5);
        break;
      case '10K':
        parentState.scale = '1:10.000';
        this.configAutoScale(10);
        break;
      default:
        //if (parentState.activeRow === 'firstRow') {
          parentState.scale = '1:25.000';
          this.configAutoScale(25);
        //}
        break;
    }

    this.props.actionScale(parentState.scale);//, option, parentState.activeRow
    if (parentState.scale === '1:50.000' || parentState.scale === '1:60.000'){
      parentState.cellDensity = "5";
    } else if (parentState.scale === '1:30.000' || parentState.scale === '1:40.000'){
      parentState.cellDensity = "2";
    }else if (parentState.scale === '1:2.500' || parentState.scale === '1:5.000'){
      parentState.cellDensity = "0.5";
    } else {
      parentState.cellDensity = "1";
    }
    this.setStateGlobal(parentState);
  }

  changeSelectedOrientation = (option) => {
    let {parentState} = this.props;
    parentState.previousOrientation = parentState.orientation;
    parentState.orientation = option;
    if(parentState.orientation === 'Paisaje'){
      this.enableVertical = false;
      parentState.verticalCartela = false;
    }
    this.setStateGlobal(parentState);
    this.props.actionOrientation(parentState.orientation);
  }

  changeSelectedCellDensity = (option) => {
    let {parentState} = this.props;
    parentState.cellDensity = option;
    this.setStateGlobal(parentState);
  }

  updateFramesValues = (option) => {
    let {parentState} = this.props;

    if (option === 'gridC') {
      if (parentState.gridFrame === 'active') {
        parentState.gridFrame = '';
      } else {
        parentState.gridFrame = 'active';
      }
    } else if (option === 'cuadriculaC') {
      if (parentState.coordinatesFrame === 'active') {
        parentState.coordinatesFrame = '';
      } else {
        parentState.coordinatesFrame = 'active';
      }
    }
    this.setStateGlobal(parentState);

  }

  changeSelectedGrid = (e) => {
    this.setState({
      [e.target.name]: e.target.checked === false
        ? ""
        : "checked"
    });
  }

  addServiceToMap = (layerName, layerUrl, selected) => {
    let {parentState} = this.props;
    if (!selected){
      window.mapJs.getImpl().getLayers().forEach(layer => {
        if (layer.name === layerName && layer.url === layerUrl) {
          window.mapJs.removeLayers(layer);
        }
      });
      delete parentState.activeServices[layerName];
    } else {
      const newService = new M.layer.WMS({
        url : layerUrl,
        name : layerName,
        legend: layerName,
        tiled: false,
      }, {});
      window.mapJs.addLayers(newService);
      parentState.activeServices[layerName] = layerUrl;
    }
    this.setStateGlobal(parentState);
  }

  selectedProductFunction = (e) => {
    const {parentState, refreshPlugin} = this.props;
    if(this.selectedProduct !== "Foto" && e === "Foto"){
      window.mapJs.getLayers().find(l=>l.legend === "orto" || l.legend === "Orto").setVisible(true); // Errores de desarrollo de apiign previstos con OR
      window.mapJs.getLayers().find(l=>l.legend === "mtn" || l.legend === "MTN").setVisible(false); // Errores de desarrollo de apiign previstos con OR
      //if(parentState.scale !== '1:25.000'){/ * CHANGE SCALE TO MAXIMUM DEFAULT 25K * /this.changeSelectedScale('25K');}if(parentState.activeRow !== 'firstRow'){parentState.activeRow = 'firstRow';}
      if (parentState.cellDensity === "5") {
        parentState.cellDensity = "2";
      }
    }
    if(this.selectedProduct === "Foto" && e !== "Foto"){
      window.mapJs.getLayers().find(l=>l.legend === "mtn" || l.legend === "MTN").setVisible(true); // Errores de desarrollo de apiign previstos con OR
      window.mapJs.getLayers().find(l=>l.legend === "orto" || l.legend === "Orto").setVisible(false); // Errores de desarrollo de apiign previstos con OR
      let auxKeys = Object.keys(parentState.activeServices);
      if(auxKeys.length !== 0){//Posibly remove services here too.
        auxKeys.forEach(k => {
          let auxLayer = window.mapJs.getImpl().getLayers().find(layer => layer.name === k && layer.url === parentState.activeServices[k]);
          if(auxLayer){
            window.mapJs.removeLayers(auxLayer);
            delete parentState.activeServices[k];
          }
        })
      }
      //if(parentState.scale !== '1:25.000'){/ * CHANGE SCALE TO MINIMUM DEFAULT 25K * /this.changeSelectedScale('25K');}if(parentState.activeRow !== 'firstRow'){parentState.activeRow = 'firstRow';}
      if (parentState.cellDensity === "0.5") {
        parentState.cellDensity = "1";
      }
    }
    if(this.selectedProduct !== e){
      this.enableLegend = false;
      parentState.posterLegend = false;
      parentState.previousOrientation = parentState.orientation;
      parentState.orientation = 'Paisaje';
      this.enableVertical = false;
      parentState.verticalCartela = false;
      const oldPlugin = window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta');
      const oldCenterFrame = oldPlugin.controls_[0].impl_.getCenter(oldPlugin.getCoordinates()[1]);
      const eventAdd = oldPlugin.controls_[0].eventsManager_.events_["added:map"];
      const eventDragEnd = oldPlugin.eventsManager_.events_.dragend;
      window.mapJs.removePlugins(oldPlugin);
      let pluginConfig = {enabled: true,posterMode: e!=='Elaborado', withLegend: e==='Poster', seriesMode: true, minHojas:10, groupOperations: true};
      let auxPlugin = new M.plugin.Mapaalacarta(pluginConfig);
      refreshPlugin(auxPlugin)
      window.mapJs.addPlugin(auxPlugin);
      let scaleZoomConfigFix = window.mapJs.getPlugins().find(p=>p.panel_ && p.panel_.name === "panelScaleZoom");
      if(scaleZoomConfigFix){
        scaleZoomConfigFix.plugin_ = auxPlugin;
        scaleZoomConfigFix.controls_[0].plugin_ = auxPlugin;
      }
      this.currentHojaCount = 0;
      this.selectedHoja = 0;
      if(parentState.activeRow !== 'firstRow'){parentState.activeRow = 'firstRow';}
      if(parentState.scale !== '1:25.000'){this.changeSelectedScale('25K');}
      this.showHelpGrid = false;
      window.grid50Layer.setVisible(false);
      window.grid25Layer.setVisible(false);
      setTimeout(()=>{
        if(oldCenterFrame){
          const defaultCenter = auxPlugin.controls_[0].impl_.defaultFrameCenter;
          const deltaX = oldCenterFrame[0] - defaultCenter[0];
          const deltaY = oldCenterFrame[1] - defaultCenter[1];
          auxPlugin.translateAll(deltaX, deltaY);
        }
        auxPlugin.setMapCenter(window.mapJs);//set map center on focused frame
        auxPlugin.controls_[0].eventsManager_.events_["added:map"] = eventAdd;
        auxPlugin.eventsManager_.events_.dragend = eventDragEnd;
        window.tmp0 = document.querySelector(".panel-content");
        window.tmp1 = document.querySelector(".scale.first-step");
        window.tmp2 = document.querySelector(".scale.second-step");
        window.tmp3 = document.querySelector(".m-panel.g-cartografia-producto-escala");
        window.tmp4 = document.querySelector(".m-panel.g-cartografia-producto-escala .divTitulo");
        window.tmp3.setAttribute("style", "display:none!important");
      },100);
    }

    this.selectedProduct = e;
    parentState.seleccionadoProductoSeries = e;
    this.setStateGlobal(parentState);
  }

  componentWillUnmount(){
    window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').setOnFocusChange(null);
  }

  toggleSeries = (evn) => {
    if(!evn.target.className.endsWith("activeTabs")){
      this.showSeries =! this.showSeries;
      const pluginMAC = window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta');
      if(this.showSeries){
        this.showSeralAlertWarning = true;
      } else {
        this.currentHojaCount = pluginMAC.getCountHojas()-1;
      }

      pluginMAC.setOnFocusChange((foc) => {
        if (this.selectedHoja !== foc){
          this.selectedHoja = foc;
          this.setState({});
        }
      });
      this.setState({});
    }
  }

  addHoja = () => {
    if (this.allowClick && this.currentHojaCount < 9) {//MAX of 10 hojas
      this.timedClick();
      if(window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').addHoja()){
        this.currentHojaCount += 1;
        if(this.props.parentState.serImgC){
          this.props.parentState.serImgC.push({
            image:IMG_CARTOGRAFIA_1_MAPPED,
            imageRotatedForVertical: null,
            imageName: 'img91.jpg',
            author:this.props.parentState.specialMapGeneration?'CNIG':'',
            title:'',
            subtitle:'',
            color: this.props.parentState.seleccionadoProductoSeries === 'Elaborado'? '#5db3ae': '#FFFFFF',
            frameColor: this.props.parentState.seleccionadoProductoSeries === 'Elaborado'? '#5db3ae': '#FFFFFF',
            portada: portada_CYAN
          });
        }
        this.setState({});
      }
    }
  }
  setFocusHoja = (newFocus) => {
    let pluginMalc = window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta');
    pluginMalc.setFocus(newFocus);
    pluginMalc.setMapCenter(window.mapJs);
    this.setState({});
  }
  removeHoja = (numHoja) => {
    if (this.allowClick && this.currentHojaCount > 0) {
      this.timedClick();
      if(window.mapJs.getPlugins().find(p => p.name === 'Mapaalacarta').removeHoja(numHoja)){
        this.currentHojaCount -= 1;
        if(this.props.parentState.serImgC){
          this.props.parentState.serImgC.splice(numHoja,1);
        }
        this.setState({});
      }
    }
  }

  timedClick(){
    this.allowClick = false;
    setTimeout(()=>{this.allowClick = true;},150);
  }

  handleCloseWizardWarningSerial = () => {
    this.showSeralAlertWarning = false;
    this.setState({});
  }

  render() {

    const {asideClassName, classPanelButton, classPanelContent, parentState} = this.props;
    const {
      orientationIMGPaisajeColor,
      orientationIMGPaisajeGris,
      orientationIMGRetratoColor,
      orientationIMGRetratoGris,
      cartelaVertical,
      cartelaVerticalGris,
      cartelaHorizontal,
      cartelaHorizontalGris,

      posterOrientationIMGPaisajeColor,
      posterOrientationIMGPaisajeGris,
      posterOrientationIMGRetratoColor,
      posterOrientationIMGRetratoGris,
      posterOrientationIMGPaisajeColor_L,
      posterOrientationIMGPaisajeGris_L,
      posterOrientationIMGRetratoColor_L,
      posterOrientationIMGRetratoGris_L,

      productoElaboradoColor,
      productoElaboradoGris,
      productoFotoColor,
      productoFotoGris,
      productoPosterColor,
      productoPosterGris,

      coordinatesIMGColor,
      coordinatesIMGGris,
      gridIMGColor,
      gridIMGGris,

      oneKMColor,
      oneKMGris,
      twoKMColor,
      twoKMGris,
      fiveKMColor,
      fiveKMGris,
    } = this.state;

    const MAPA_ELABORADO = i18n.t('step1.elaborado') || 'Elaborado';
    const MAPA_POSTER = i18n.t('step1.poster') || 'Póster';
    const MAPA_FOTO = i18n.t('step1.photo') || 'Foto';

    const ShowHojas = [];
    for (let k = 1; k <= this.currentHojaCount+1; k++){
      ShowHojas.push(
        <li key={k.toString()} className={this.selectedHoja === (k-1)?'activeSheet':''}>
          <span className='simpleFlex' style={{flex: '10 0 auto'}}><span className="sheetText"><Trans i18nKey="step1.sheet">Hoja</Trans> </span>{k}</span>
          <button className='simpleFlex g-cartografia-mano2' onClick={this.setFocusHoja.bind(null,k-1)} style={{margin: '0 auto 0 auto', cursor: 'pointer'}}></button>
          <button className='simpleFlex editiontools-papelera' onClick={this.removeHoja.bind(null,k-1)} style={{marginLeft: '15px', cursor: 'pointer'}}></button>
        </li>
      );
    }

    const services = []

    for (let i = 0; i < properties.SERVICE_NAMES.length; i++){
      services.push(
        <React.Fragment key={'service' + i}>
          <li className="serviceElement">
            <Service id={properties.SERVICE_NAMES[i]} label={properties.SERVICE_DISPLAY_NAMES[i]} urlService={properties.SERVICE_URLS[i]}  selected={parentState.activeServices.hasOwnProperty(properties.SERVICE_NAMES[i])} onClick={this.addServiceToMap}/>
          </li>
        </React.Fragment>
      );
    }

    // modal for centroidSheet empty

    return (<aside className={asideClassName}>
      <div className={classPanelButton}>
        <div className='open'>
          <i className='fas fa-arrow'></i>
        </div>
      </div>

      <div className={classPanelContent}>
        <div className='TabsList'>
          <div className={this.showSeries?'tabsOption activeTabs':'tabsOption'} onClick={this.toggleSeries}><Trans i18nKey="step1.configSerie">Configuración de la serie</Trans></div>
          <div className={this.showSeries?'tabsOption':'tabsOption activeTabs'} onClick={this.toggleSeries}><Trans i18nKey="step1.configSheet">Configuración de la hoja</Trans></div>
        </div>
        <div style={!this.showSeries?{display: 'none'}:{}}>
          {/* PRODUCTO */}
          <React.Fragment>
          <h2 className="h2Custom"><Trans i18nKey="step1.product">Producto</Trans></h2>
          <div className='orientation center product-step' style={{marginBottom: '10px'}}>
            <Orientation classNameDiv="horizontal" className="center" src={productoElaboradoColor} srcChange={productoElaboradoGris} value={MAPA_ELABORADO} label="Elaborado" checkedI="checked mc-check" selected={parentState.seleccionadoProductoSeries} onClick={this.selectedProductFunction}/>
            <Orientation classNameDiv="horizontal" className="center" src={productoPosterColor} srcChange={productoPosterGris} value={MAPA_POSTER} label="Poster" checkedI="checked mc-check" selected={parentState.seleccionadoProductoSeries} onClick={this.selectedProductFunction}/>
            <Orientation classNameDiv="horizontal" className="center" src={productoFotoColor} srcChange={productoFotoGris} value={MAPA_FOTO} label="Foto" checkedI="checked mc-check" selected={parentState.seleccionadoProductoSeries} onClick={this.selectedProductFunction}/>
          </div>
          {this.selectedProduct !== 'Foto' && (//POSTER #1 or ELABORADO #1
            <div className="scale first-step" style={{position:"relative"}}>
              <div className="radiobutton-row center scaleOption">
                <span><input type="radio" id="opt1" name="drone" value="firstRow" checked={parentState.activeRow === 'firstRow'} onChange={this.setActiveRow}/>
                <label htmlFor="opt1">1:25.000</label></span>
                <div className="showGridHelp" style={{display:parentState.activeRow === 'firstRow'?"flex":"none"}}>
                  <input id="opt1_grid" type="checkbox" checked={this.showHelpGrid} onClick={this.toggleHelpGrid} readOnly />
                  <label style={{display: "inline-block"}}><Trans i18nKey="step1.seeGrid">Visualizar cuadrículas</Trans></label>
                </div>
              </div>
              <div className="radiobutton-row center scaleOption">
                <span><input type="radio" id="opt2" name="drone" value="secondRow" checked={parentState.activeRow === 'secondRow'} onChange={this.setActiveRow}/>
                <label htmlFor="opt2">1:50.000</label></span>
                <div className="showGridHelp" style={{display:parentState.activeRow === 'secondRow'?"flex":"none"}}>
                  <input id="opt2_grid" type="checkbox" checked={this.showHelpGrid} onClick={this.toggleHelpGrid} readOnly />
                  <label style={{display: "inline-block"}}><Trans i18nKey="step1.seeGrid">Visualizar cuadrículas</Trans></label>
                </div>
              </div>
            </div>
          )}
          </React.Fragment>
          {/* Servicios */}
          {this.selectedProduct === 'Foto' && (//FOTO #1
            <h2 className="h2Custom"><Trans i18nKey="step1.services">Servicios</Trans></h2>
          )}
          {this.selectedProduct === 'Foto' && (//FOTO #1
            <div className="scale first-step">
              <div className="radiobutton-row center" >
                <ul>
                {services}
                </ul>
              </div>
            </div>
          )}

          {/* ESCALA */}
          <h2 className="h2Custom fullScreenScaleREF"><Trans i18nKey="step1.scale">Escala</Trans></h2>
          <div className={"scale second-step" +(this.selectedProduct === 'Foto'?' fullViewFoto':'')}>

            {this.selectedProduct !== 'Foto' && (//POSTER #2 or ELABORADO #2
              <div className="radiobutton-row center scaleMenu">
                { this.props.parentState.activeRow === 'firstRow' ? (<React.Fragment>
                <Scale scale={parentState.scale} className='small' classNameActive='small active' label='30K' tooltipText='1:30.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
                <Scale scale={parentState.scale} className='medium' classNameActive='medium active' label='25K' tooltipText='1:25.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
                <Scale scale={parentState.scale} className='large' classNameActive='large active' label='20K' tooltipText='1:20.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
                </React.Fragment>) : <React.Fragment>
                <Scale scale={parentState.scale} className='small' classNameActive='small active' label='60K' tooltipText='1:60.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
                <Scale scale={parentState.scale} className='medium' classNameActive='medium active' label='50K' tooltipText='1:50.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
                <Scale scale={parentState.scale} className='large' classNameActive='large active' label='40K' tooltipText='1:40.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
                </React.Fragment>}
              </div>
            )}

            {this.selectedProduct === 'Foto' && (//FOTO #2
              <div className="radiobutton-row center" >
                <Scale scale={parentState.scale} className='small' classNameActive='small active' label='25K' tooltipText='1:25.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
                <Scale scale={parentState.scale} className='medium-low' classNameActive='medium-low active' label='10K' tooltipText='1:10.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
                <Scale scale={parentState.scale} className='medium-high' classNameActive='medium-high active' label='5K' tooltipText='1:5.000' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
                <Scale scale={parentState.scale} className='large' classNameActive='large active' label='2.5K' tooltipText='1:2.500' selected={parentState.selectedRow} onClick={this.changeSelectedScale}/>
              </div>
            )}
          </div>
          {/* ORIENTACION MAPA*/}
          <h2 className="h2Custom"><Trans i18nKey="step1.orientation">Orientación</Trans></h2>
          {this.selectedProduct === 'Elaborado' && (//ELABORADO #3
            <div className="orientation center third-step">
              <Orientation classNameDiv="horizontal" className="center" src={orientationIMGPaisajeColor} srcChange={orientationIMGPaisajeGris} value={i18n.t('step1.horizontal')} label="Paisaje" checkedI="checked mc-check" selected={parentState.orientation} onClick={this.changeSelectedOrientation}/>
              <Orientation classNameDiv="vertical" className="center" src={orientationIMGRetratoColor} srcChange={orientationIMGRetratoGris} value={i18n.t('step1.vertical')} label="Retrato" checkedI="checked mc-check" selected={parentState.orientation} onClick={this.changeSelectedOrientation}/>
            </div>
          )}

          {(this.selectedProduct === 'Poster' || this.selectedProduct === 'Foto') && (//POSTER #3 or FOTO #3
            <div className="orientation center third-step">
              <Orientation classNameDiv="horizontal" className="center" src={this.enableLegend?posterOrientationIMGPaisajeColor_L:posterOrientationIMGPaisajeColor} srcChange={this.enableLegend?posterOrientationIMGPaisajeGris_L:posterOrientationIMGPaisajeGris} value={i18n.t('step1.horizontal')} label="Paisaje" checkedI="checked mc-check" selected={parentState.orientation} onClick={this.changeSelectedOrientation}/>
              <Orientation classNameDiv="vertical" className="center" src={this.enableLegend?posterOrientationIMGRetratoColor_L:posterOrientationIMGRetratoColor} srcChange={this.enableLegend?posterOrientationIMGRetratoGris_L:posterOrientationIMGRetratoGris} value={i18n.t('step1.vertical')} label="Retrato" checkedI="checked mc-check" selected={parentState.orientation} onClick={this.changeSelectedOrientation}/>
            </div>
          )}
          {this.selectedProduct === 'Poster' && (//POSTER #4
            <div className="applyLegend">
              <input id="leyend_state" type="checkbox" checked={this.enableLegend} onClick={this.toggleLegend} readOnly/>
              <label><Trans i18nKey="step1.legend">Leyenda</Trans></label>
            </div>
          )}

          {/* ORIENTACION CARTELA*/}
          {this.selectedProduct === 'Elaborado' && (//ELABORADO #4
            <h2 className="h2Custom"><Trans i18nKey="step1.orientationCartela">Orientación cartela</Trans></h2>
          )}
          {this.selectedProduct === 'Elaborado' && (//ELABORADO #4
            <div className="orientation center cartela-step">
              <Cartela className='medium Cartela' classNameActive='medium Cartela active' src={cartelaVertical} srcChange={cartelaVerticalGris} checkedI="checked mc-check" classNameDiv="horizontal" label={i18n.t('step1.vertical')} selected={!this.enableVertical} onClick={this.toggleVertical}/>
              <Cartela className='medium rotatedCartela' classNameActive='medium rotatedCartela active' src={cartelaHorizontal} srcChange={cartelaHorizontalGris} checkedI="checked mc-check" classNameDiv="vertical" label={i18n.t('step1.horizontal')} selected={this.enableVertical} onClick={this.toggleVertical}/>
            </div>
          )}
          {/* CUADRÍCULAS */}
          <h2 className="h2Custom"><Trans i18nKey="step1.grid">Cuadrículas</Trans></h2>

          <div className="orientation center fourth-step">
            <Grid classNameDiv="gridC" className="center" src={gridIMGColor} srcChange={gridIMGGris} label={i18n.t('step1.grid')} checkedI="checked mc-check" selected={parentState.gridFrame} onClick={this.updateFramesValues}/>
            <Grid classNameDiv="cuadriculaC" className="center" src={coordinatesIMGColor} srcChange={coordinatesIMGGris} label={i18n.t('step1.coordinates')} checkedI="checked mc-check" selected={parentState.coordinatesFrame} onClick={this.updateFramesValues}/>
          </div>

          {/* DENSIDAD DE CUADRÍCULA */}
          { this.props.parentState.gridFrame !== '' || this.props.parentState.coordinatesFrame !== '' ? <React.Fragment><h2 className="h2Custom"><Trans i18nKey="step1.cellDimension">Dimensiones de la celda</Trans></h2>

          {this.selectedProduct !== 'Foto' && (//POSTER #2 or ELABORADO #2
          <div className="orientation center">
            <CellDensity classNameDiv="OneKMC" className="center" src={oneKMColor} srcChange={oneKMGris} value="1 Km" label="1" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
            <CellDensity classNameDiv="TwoKMC" className="center" src={twoKMColor} srcChange={twoKMGris} value="2 Km" label="2" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
            <CellDensity classNameDiv="FiveKMC" className="center" src={fiveKMColor} srcChange={fiveKMGris} value="5 Km" label="5" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
          </div>
          )}
          {this.selectedProduct === 'Foto' && (//FOTO
          <div className="orientation center">
            <CellDensity classNameDiv="OneKMC" className="center" src={oneKMColor} srcChange={oneKMGris} value="500 m" label="0.5" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
            <CellDensity classNameDiv="TwoKMC" className="center" src={twoKMColor} srcChange={twoKMGris} value="1 Km" label="1" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
            <CellDensity classNameDiv="FiveKMC" className="center" src={fiveKMColor} srcChange={fiveKMGris} value="2 Km" label="2" checkedI="checked mc-check" selected={parentState.cellDensity} onClick={this.changeSelectedCellDensity}/>
          </div>
          )}
          </React.Fragment> : <React.Fragment/>}
        </div>

        <div style={this.showSeries?{display: 'none'}:{}}>
          <div className='listSheetRow'>
            <button className='simpleFlex g-cartografia-mas' onClick={this.addHoja} style={{cursor: 'pointer'}}></button>
            <h2 className="h2Custom"><Trans i18nKey="step1.listSheet">Lista Hojas</Trans></h2>
          </div>
          <ul className='listSheetStyle'>
            {ShowHojas}
          </ul>
        </div>

      </div>
      <Dialog open={this.showSeralAlertWarning} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <ThemeProvider theme={themeTitle}>
            <DialogTitle id="alert-dialog-title">{"Advertencia"}</DialogTitle>
          </ThemeProvider>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Trans i18nKey="dialog.serialOptions">
                Retroceder y modificar estas configuraciones puede causar perdida de configuración de hojas.
              </Trans>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <ThemeProvider theme={theme}>
              <DialogButton size="small" variant="contained" color="primary" onClick={this.handleCloseWizardWarningSerial}>
              <Trans i18nKey="dialog.accept">
                Aceptar
              </Trans>
              </DialogButton>
            </ThemeProvider>
          </DialogActions>
        </Dialog>
    </aside>);
  }
}
export default OptionMapSelectorSeries;
